import React, { useEffect, useState } from 'react';
import * as UIcons from '@iconscout/react-unicons';
import { yupResolver } from '@hookform/resolvers/yup';
import { withTranslation } from 'react-i18next';
import { FormProvider, useForm } from 'react-hook-form';
import Btn from 'components/Btn';
import { SocialMediaValidation } from 'pages/Settings/validation';
import { apiRequest } from 'store/Misc/apiRequest';
import { toast } from 'react-toastify';

export default withTranslation()(function SocialMediaForm({ t, name, action, info, defaultValue }) {

  const method = useForm({
    mode: 'all',
    resolver: yupResolver(SocialMediaValidation)
  });
  const [defaults, setDefaults] = useState({})
  useEffect(() => {
    // setDefaults(JSON.parse(info?.extrat_data?.social_media))
    if (defaultValue) setDefaults(defaultValue)
  }, [defaultValue])

  const { watch, register } = method;

  const submit = async (payload) => {
    await apiRequest({
      method: 'post',
      url: 'settings/business-info',
      payload: {
        // avatar:info.avatar,
        social_media: {
          [name]: payload
        }
      }
    })
      .then(res => { toast.success(`Successfully updated ${name} link`); action(null) })
      .catch(err => toast.error('Please check your network'));

  }

  return (
    <FormProvider {...method}>
      <div className="w-full flex items-center justify-end relative col-span-2" >
        <input
          type="text"
          name={name}
          // www.${name}.com/
          defaultValue={defaults[name]}
          className="p-3 border border-primary focus:border-2 focus:border-primary mr-2 rounded-lg"
          {...register(name)}
        />

        <div className="border border-primary w-20 md:w-24 h-10 overflow-hidden rounded-lg">
          <Btn
            content={t('misc.submit')}
            textColor="text-primary font-semibold"
            className="w-20 md:w-24 h-10 bg-dark text-primary font-semibold hover:text-white"
            bg="transparent"
            click={() => submit(watch(name))}
          />
        </div>

        <div className="absolute right-1 -top-7 md:hidden">
          <UIcons.UilTimes
            className="text-primary ml-2"
            onClick={() => action(null)}
          />
        </div>

        <div className="hidden md:block">
          <UIcons.UilTimes
            className="text-primary ml-2"
            onClick={() => action(null)}
          />
        </div>
      </div>
    </FormProvider>
  )
})
